const checkSrcDocSupported = (): boolean => !!('srcdoc' in document.createElement('iframe'));

export default checkSrcDocSupported;
